<script setup lang="ts">
import { useUserStore } from '@core/stores/user'
import GamesTable from '@/views/pages/games/GamesTable.vue'
import PlayersRatingCard from '@/views/dashboards/PlayersRatingCard.vue'
import PlayerLastGamesEffectiveness from '@/views/dashboards/PlayerLastGamesEffectiveness.vue'
import PlayerCompetenceRadarCard from '@/views/dashboards/PlayerCompetenceRadarCard.vue'
import PlayerSummary from '@/views/dashboards/PlayerSummary.vue'
import { App, Modules } from '@/types/generated'
import UserData = App.Http.Controllers.Auth.UserData
import OrganizationSettingsData = Modules.Organization.OrganizationSettingsData
import { hidePlayerRating } from '@/utils/helpers'

const userData = useCookie<UserData>('userData')

const userRoles: string [] = userData.value?.roles ?? []
const { t } = useI18n()
const organizationSettings = useCookie<OrganizationSettingsData>('organizationSettings')

const hideRating = hidePlayerRating(userRoles, organizationSettings.value)

definePage({
  meta: {
    action: 'read',
    subject: 'dashboard-player',
  },
})

const userStore = useUserStore()
</script>

<template>
  <div>
    <VRow class="pt-6">
      <!-- 👉 Welcome -->
      <VCol
        cols="12"
        md="8"
        class="match-height"
      >
        <div class="pe-3">
          <h5 class="text-h5 mb-2">
            {{ t('dashboards.player.summary.welcome') }}, <span class="text-h4"> {{ userStore.fullName.split(' ')[0] }} 👋🏻 </span>
          </h5>

          <div
            class="text-wrap text-body-1"
            style="max-inline-size: 360px;"
          >
            {{ t('dashboards.player.summary.progress') }}:
          </div>

          <div class="d-flex justify-space-between flex-wrap gap-4 flex-column flex-sm-row mt-10">
            <PlayerSummary />
          </div>
        </div>
      </VCol>

      <!-- 👉 Time Spending -->
      <VCol
        cols="12"
        md="4"
      >
        <PlayerLastGamesEffectiveness />
      </VCol>
    </VRow>

    <VRow class="match-height">
      <!-- 👉 Topics you are interested in -->
      <VCol
        cols="12"
        :md="hideRating ? 12 : 8"
      >
        <PlayerCompetenceRadarCard
          :user-data="null"
          :for-manager="false"
        />
      </VCol>
      <VCol
        v-if="!hideRating"
        cols="12"
        md="4"
      >
        <PlayersRatingCard />
      </VCol>

      <VCol>
        <GamesTable
          :show-add-button="true"
          for-participant
          :for-expert="false"
          :player-id="null"
        />
      </VCol>
    </VRow>
  </div>
</template>

<style lang="scss">
@use "@core-scss/template/libs/apex-chart.scss";
</style>
